import { Button } from '@/components/ui/button';
import { LogOut, Bell, Shield } from 'lucide-react';

export function UserHeader({ user, unreadCount, onOpenNotifications, onLogout, navigate }) {
  return (
    <header className="bg-white/80 backdrop-blur-md border-b border-slate-200/50 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 sm:py-4">
        <div className="flex justify-between items-center">
          <div className="min-w-0">
            <h1 className="text-lg sm:text-2xl font-black text-slate-900 truncate" data-testid="user-dashboard-title">Olá, {user?.name}</h1>
            <p className="text-xs sm:text-sm text-slate-600">Nível {user?.gamification_level} - {user?.gamification_points} pontos</p>
          </div>
          <div className="flex items-center gap-1 sm:gap-2 shrink-0">
            <Button variant="ghost" size="sm" onClick={() => navigate('/edit-user-profile')} className="text-slate-600 hover:text-slate-600 px-2 sm:px-3" data-testid="edit-user-profile-btn">
              <span className="hidden sm:inline">Meu Perfil</span>
              <span className="sm:hidden text-xs">Perfil</span>
            </Button>
            {(user?.role === 'admin' || user?.email === 'clubdocupom.com@gmail.com' || user?.email === 'donato.coutinho@gmail.com') && (
              <Button variant="ghost" size="sm" onClick={() => navigate('/admin')} className="text-red-500 hover:text-red-600 px-2 sm:px-3" data-testid="admin-panel-btn">
                <Shield className="h-4 w-4 sm:mr-1" /><span className="hidden sm:inline">Admin</span>
              </Button>
            )}
            <Button variant="ghost" size="sm" onClick={onOpenNotifications} className="text-slate-600 hover:text-slate-600 relative px-2 sm:px-3" data-testid="notifications-btn">
              <Bell className="h-5 w-5" />
              {unreadCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-bold">{unreadCount > 9 ? '9+' : unreadCount}</span>
              )}
            </Button>
            <Button variant="ghost" size="sm" onClick={onLogout} className="text-slate-600 hover:text-slate-600 px-2 sm:px-3" data-testid="logout-btn">
              <LogOut className="h-5 w-5" /><span className="hidden sm:inline ml-2">Sair</span>
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
}
